import { getUserInfo } from "@/services/getUserInfo";
import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { useErrorHandler } from "@/hooks/useErrorHandler";

const useGetUserInfo = () => {
  const { errorHandler } = useErrorHandler();

  const { data, isLoading, refetch, isError, error, failureCount, ...rest } = useQuery({
    queryKey: ["user-info"],
    queryFn: async () => {
      try {
        return await getUserInfo();
      } catch (error: unknown) {
        if (error instanceof AxiosError && failureCount === 3) {
          await errorHandler(error, {
            eventName: "GET-USER-INFO",
            showToast: true,
            properties: {
              endpoint: "/info",
              reason: `Error loading user´s info - ${error?.message}`,
            },
          });
        }
        throw error;
      }
    },
    enabled: false,
    staleTime: 1000 * 60 * 60,
    refetchInterval: 1000 * 60 * 60,
  });

  return {
    data,
    isLoadingUserInfo: isLoading,
    refetchUserInfo: refetch,
    isError,
    error,
    ...rest,
  };
};

export default useGetUserInfo;
